<template>
	<ul class="navbar-nav">
		<main-nav-node
			v-for="(node, i) in activeMenuItems"
			:key="i" :node="node"
			class="nav-item"
			:show-submenu-force="openAllSubmenus"
			>
			<img v-if="blockedApps.includes(node.route)" src="/images/pro.png" style="width: 16px; margin-right:14px; margin-left:4px;" class="nav-icon"/>
			<i v-else-if="node.icon" class="nav-icon" :class="node.icon"></i>
			<span class="nav-text" :class="{'opacity-50': blockedApps.includes(node.route)}">{{ node.title }}</span>
		</main-nav-node>
	</ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
	props: {
		tree: {
			type: Array,
			default: [],
		},
		openAllSubmenus: {
			type: Boolean,
			default: false,
		}
	},
	computed: {
		...mapState({
			_TENANT: (state) => state.tenant,
		}),
		blockedApps() {
			return this.tenant.blocked_apps.length ? this.tenant.blocked_apps.concat(['settingsIntegrations']) : [];
		},
		activeMenuItems(){
			return this._NAV.setNavTree(this.tree).getNavNodes();
		}
	}
};
</script>